import React from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import fcbLogo from 'assets/images/foodcourt-business-logo.png';
import { EventSummaryType } from './types';
import moment from 'moment';
import { formatCurrency } from 'utils/functions';

type Props = {
  elementRef: React.LegacyRef<HTMLDivElement>;
  summary: EventSummaryType;
};

const StatementSummary = (props: Props) => {
  const { elementRef, summary } = props;
  const { activeCompany } = useDashboardContext();

  return (
    <div ref={elementRef} className='fixed -top-[200vh] -z-10 w-[595px]'>
      <div className='flex items-start justify-between px-[22px] pt-6 pb-4 border-b border-[#EAEAEB]'>
        <img src={fcbLogo} className='w-[109px]' />
        <article className='max-w-[138px] text-right'>
          <p className='text-xs font-semibold'>{activeCompany.name}</p>
          <p className='text-[10px] leading-[16px]'>{activeCompany.address}</p>
        </article>
      </div>
      <div className='flex flex-col gap-3 px-[22px] pt-6'>
        <article>
          <p className='text-xs font-medium text-[#E60A2B]'>Account Summary</p>
        </article>
        <ul className='flex flex-col gap-2 p-4 pt-1 border text-xs border-[#EAEAEB]'>
          <li className='flex items-center justify-between'>
            <p>Event name</p>
            <p className='text-[#5E6164]'>{summary.name}</p>
          </li>
          <li className='flex items-center justify-between'>
            <p>Event wallet opening balance</p>
            <p className='text-[#5E6164]'>{formatCurrency(summary.opening_balance)}</p>
          </li>
          <li className='flex items-center justify-between'>
            <p>Event start date</p>
            <p className='text-[#5E6164]'>{moment(summary.start_date).format('Do MMMM, YYYY')}</p>
          </li>
          <li className='flex items-center justify-between'>
            <p>Event end state</p>
            <p className='text-[#5E6164]'>{moment(summary.end_date).format('Do MMMM, YYYY')}</p>
          </li>
          <li className='flex items-center justify-between'>
            <p>Event wallet closing balance</p>
            <p className='text-[#5E6164]'>{formatCurrency(summary.closing_balance)}</p>
          </li>
          <li className='flex items-center justify-between'>
            <p>Total no. of guests</p>
            <p className='text-[#5E6164]'>{summary.guest_count}</p>
          </li>
        </ul>
        <p className='text-xs font-medium text-[#E60A2B] py-4'>Transaction Breakdown</p>
      </div>
    </div>
  );
};

export default StatementSummary;
